import React, { useEffect, useState } from "react";
import { ErrorBoundary, withErrorBoundary } from 'react-error-boundary'

//interface IHideLogBoundaryProps {
//    children: Element
//}

function EmptyFallback() {
    return <></>
}

function HideLogBoundary({ children }): JSX.Element {
    return <ErrorBoundary 
        FallbackComponent={EmptyFallback}
        onError={(error, info) => {
            console.log('error caught', error, info)
        }}
    >
        { children}
        </ErrorBoundary>
}

export default HideLogBoundary;